import { createSubscriptionTemplate } from "../services/subTemplateService";

export const SubscriptionManager = async (subscriptions) => {
    if (!subscriptions || subscriptions.length === 0) {
        throw new Error("No subscriptions to create");
    }

    const results = [];

    for (const sub of subscriptions) {
        const payload = {
            anchor: sub.anchor,
            subscription: sub.subscription,
            watemplate: sub.watemplate,
            day: sub.day,
            time: sub.time,
        };

        try {
            const result = await createSubscriptionTemplate(payload);
            results.push({ success: true, data: result });
        } catch (error) {
            results.push({ success: false, error: error.message });
        }
    }

    return results; 
};
